import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./ProfileCarousel.css";

const ProfileCarousel = ({ profileData, onProfileClick }) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleTiles = 6;

  const handleNext = () => {
    setStartIndex((prevIndex) => 
      Math.min(prevIndex + 1, profileData.length - visibleTiles)
    );
  };

  const handlePrev = () => {
    setStartIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  return (
    <div className="carousel-container">
      <button className="nav-button left" onClick={handlePrev} disabled={startIndex === 0}>
        <FaChevronLeft />
      </button>
      <div className="carousel">
        {profileData.slice(startIndex, startIndex + visibleTiles).map((profile) => (
          <div 
            key={profile.id} 
            className="tile" 
            onClick={() => {
              console.log("Clicked Profile:", profile); // Debugging log
              onProfileClick(profile);
            }}
          >
            <img src={profile.img} alt={profile.name} className="profile-pic" />
            <span className="profile-name">{profile.name}</span>
          </div>
        ))}
      </div>
      <button 
        className="nav-button right" 
        onClick={handleNext} 
        disabled={startIndex >= profileData.length - visibleTiles}
      >
        <FaChevronRight />
      </button>
    </div>
  );
};

export default ProfileCarousel;